import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { PorteBeneficiario } from "src/app/model/porte-beneficiario-model";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ResultadoPaginado } from "src/app/model/resultado";

@Injectable({
  providedIn:'root'
})
export class PorteBeneficiarioService extends FgiBackEndService<PorteBeneficiario> {

    getNewEntity(): PorteBeneficiario {
        return null;
    }

    protected getResourceURL(): string {
        return 'front/porte-empresa-cliente'
    }

    public listarTodos(page: number, limite: number = 10): Observable<ResultadoPaginado<PorteBeneficiario>> {
        const options: any = blockUi();
        options.params.pagina = page;
        options.params.limite = limite;
        return this.http.get<ResultadoPaginado<PorteBeneficiario>>(`${this.BASE_URL}`, options).pipe
        (catchError((e) => this.handleError(e))) as Observable<any>
    }
}